import { createStore } from 'vuex'
import LeftSidebarCreate from './modules/LeftSidebar/create'
import editquestionEdit from './modules/editquestion/edit'
import editquestion from './modules/editquestion/index'
import previewSurvey from './modules/PreviewSurvey/index'

export default createStore({
  modules: {
    LeftSidebarCreate,
    editquestionEdit,
    editquestion,
    previewSurvey
  },
  strict: false
})
